import { SUPPORT_EMAIL } from '@constants';
import Icon, { IconType } from 'components/Icon';
import { useTheme } from 'styled-components';
import * as Base from '../styles';
import * as S from './styles';

interface ErrorOverlayProps {
	text: string;
	showProjectsLink?: boolean;
}

const ErrorOverlay = ({ text, showProjectsLink }: ErrorOverlayProps) => {
	const theme = useTheme();

	return (
		<Base.Base semiTransparent={false} data-testid="error-overlay">
			<Base.Container>
				<S.Wrapper>
					<Icon type={IconType.ERROR} width={36} height={36} color={theme.gray[1000]} />

					<Base.Text>{text}</Base.Text>
				</S.Wrapper>
				{showProjectsLink && <S.Link href="/">Projects Home</S.Link>}
				<S.Link href={`mailto:${SUPPORT_EMAIL}`}>Contact Support</S.Link>
			</Base.Container>
		</Base.Base>
	);
};

export default ErrorOverlay;
